enum AngularRootScopeEvent {
    StateChangeSuccess = "$stateChangeSuccess",
    StateChangeStart = "$stateChangeStart",
    Web1LocalizationUpdate = "ph.localize.update"
}

export default AngularRootScopeEvent;
